import { OpenIdError } from './OpenIdError';
function isOAuth2Error(data) {
    return (typeof data === 'object' &&
        data !== null &&
        typeof data.error === 'string');
}
export function assertIsNotOAuth2Error(data) {
    if (!isOAuth2Error(data))
        return;
    throw new OpenIdError(`OAuth error - ${data.error}`, {
        data,
    });
}
